import { LabelTypes } from 'components/types/parts/label';
import { useEffect, useMemo, useState } from 'react';

function Label({
  id, typeLabel, children, style, className, ...props
}: LabelTypes) {
  const [classNameStyle, setClassNameStyle] = useState('');

  useEffect(() => {
    if (typeLabel !== '') {
      switch (typeLabel) {
        case 'fs28fw700':
          setClassNameStyle('fs28fw700');
          break;
        case 'fs24fw700':
          setClassNameStyle('fs24fw700');
          break;
        case 'f18w700':
          setClassNameStyle('label_1');
          break;
        case 'f14w400':
          setClassNameStyle('label_2');
          break;
        case 'f12w400':
          setClassNameStyle('fs12fw400');
          break;
        case 'fs14fw700':
          setClassNameStyle('fs14fw700');
          break;
        case 'fs16fw500':
          setClassNameStyle('fs16fw500');
          break;
        case 'fs16fw700':
          setClassNameStyle('fs16fw700');
          break;
        case 'fs10fw500':
          setClassNameStyle('fs10fw500');
          break;
        case 'fs8fw500':
          setClassNameStyle('fs8fw500');
          break;
        case 'label_page':
          setClassNameStyle('label_title_page');
          break;
        case 'label_table':
          setClassNameStyle('label_title_table');
          break;
        case 'label_option':
          setClassNameStyle('label_option');
          break;
        case 'label_modal':
          setClassNameStyle('label_modal');
          break;
        case 'label_modal2':
          setClassNameStyle('label_modal2');
          break;
        case 'label_error':
          setClassNameStyle('label_is_invalid');
          break;
        default:
          setClassNameStyle('label_text');
          break;
      }
    }
  }, [typeLabel]);

  return (
    <p id={id} className={`${className} mb-0 ${classNameStyle}`} style={style}>
      {children}
    </p>
  );
}

export default Label;
